/* tslint:disable */
/* eslint-disable */
/**
 * Doppio API
 * Microservice backend for ...
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    Notification,
    NotificationFromJSON,
    NotificationToJSON,
} from '../models';

export interface ListNotificationsRequest {
    notificationName: string;
    notificationType: ListNotificationsNotificationTypeEnum;
    entityId?: string;
    entityIds?: Array<string>;
}

export interface NotifyRequest {
    notificationName: string;
    notificationType: NotifyNotificationTypeEnum;
    entityId?: string;
    entityIds?: Array<string>;
}

export interface PreviewNotificationRequest {
    notificationName: string;
    notificationType: PreviewNotificationNotificationTypeEnum;
    entityId?: string;
    entityIds?: Array<string>;
    i?: number;
}

/**
 * NotificationsApi - interface
 * 
 * @export
 * @interface NotificationsApiInterface
 */
export interface NotificationsApiInterface {
    /**
     * 
     * @param {string} notificationName 
     * @param {'EMAIL' | 'MAIL' | 'SLACK' | 'SMS'} notificationType 
     * @param {string} [entityId] 
     * @param {Array<string>} [entityIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApiInterface
     */
    listNotificationsRaw(requestParameters: ListNotificationsRequest): Promise<runtime.ApiResponse<Array<Notification>>>;

    /**
     */
    listNotifications(requestParameters: ListNotificationsRequest): Promise<Array<Notification>>;

    /**
     * 
     * @param {string} notificationName 
     * @param {'EMAIL' | 'MAIL' | 'SLACK' | 'SMS'} notificationType 
     * @param {string} [entityId] 
     * @param {Array<string>} [entityIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApiInterface
     */
    notifyRaw(requestParameters: NotifyRequest): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     */
    notify(requestParameters: NotifyRequest): Promise<{ [key: string]: any; }>;

    /**
     * 
     * @param {string} notificationName 
     * @param {'EMAIL' | 'MAIL' | 'SLACK' | 'SMS'} notificationType 
     * @param {string} [entityId] 
     * @param {Array<string>} [entityIds] 
     * @param {number} [i] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApiInterface
     */
    previewNotificationRaw(requestParameters: PreviewNotificationRequest): Promise<runtime.ApiResponse<string>>;

    /**
     */
    previewNotification(requestParameters: PreviewNotificationRequest): Promise<string>;

}

/**
 * 
 */
export class NotificationsApi extends runtime.BaseAPI implements NotificationsApiInterface {

    /**
     */
    async listNotificationsRaw(requestParameters: ListNotificationsRequest): Promise<runtime.ApiResponse<Array<Notification>>> {
        if (requestParameters.notificationName === null || requestParameters.notificationName === undefined) {
            throw new runtime.RequiredError('notificationName','Required parameter requestParameters.notificationName was null or undefined when calling listNotifications.');
        }

        if (requestParameters.notificationType === null || requestParameters.notificationType === undefined) {
            throw new runtime.RequiredError('notificationType','Required parameter requestParameters.notificationType was null or undefined when calling listNotifications.');
        }

        const queryParameters: any = {};

        if (requestParameters.entityId !== undefined) {
            queryParameters['entity_id'] = requestParameters.entityId;
        }

        if (requestParameters.entityIds) {
            queryParameters['entity_ids'] = requestParameters.entityIds;
        }

        if (requestParameters.notificationName !== undefined) {
            queryParameters['notification_name'] = requestParameters.notificationName;
        }

        if (requestParameters.notificationType !== undefined) {
            queryParameters['notification_type'] = requestParameters.notificationType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/notifications/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(NotificationFromJSON));
    }

    /**
     */
    async listNotifications(requestParameters: ListNotificationsRequest): Promise<Array<Notification>> {
        const response = await this.listNotificationsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async notifyRaw(requestParameters: NotifyRequest): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters.notificationName === null || requestParameters.notificationName === undefined) {
            throw new runtime.RequiredError('notificationName','Required parameter requestParameters.notificationName was null or undefined when calling notify.');
        }

        if (requestParameters.notificationType === null || requestParameters.notificationType === undefined) {
            throw new runtime.RequiredError('notificationType','Required parameter requestParameters.notificationType was null or undefined when calling notify.');
        }

        const queryParameters: any = {};

        if (requestParameters.entityId !== undefined) {
            queryParameters['entity_id'] = requestParameters.entityId;
        }

        if (requestParameters.entityIds) {
            queryParameters['entity_ids'] = requestParameters.entityIds;
        }

        if (requestParameters.notificationName !== undefined) {
            queryParameters['notification_name'] = requestParameters.notificationName;
        }

        if (requestParameters.notificationType !== undefined) {
            queryParameters['notification_type'] = requestParameters.notificationType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/notifications/notify/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async notify(requestParameters: NotifyRequest): Promise<{ [key: string]: any; }> {
        const response = await this.notifyRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async previewNotificationRaw(requestParameters: PreviewNotificationRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.notificationName === null || requestParameters.notificationName === undefined) {
            throw new runtime.RequiredError('notificationName','Required parameter requestParameters.notificationName was null or undefined when calling previewNotification.');
        }

        if (requestParameters.notificationType === null || requestParameters.notificationType === undefined) {
            throw new runtime.RequiredError('notificationType','Required parameter requestParameters.notificationType was null or undefined when calling previewNotification.');
        }

        const queryParameters: any = {};

        if (requestParameters.entityId !== undefined) {
            queryParameters['entity_id'] = requestParameters.entityId;
        }

        if (requestParameters.entityIds) {
            queryParameters['entity_ids'] = requestParameters.entityIds;
        }

        if (requestParameters.i !== undefined) {
            queryParameters['i'] = requestParameters.i;
        }

        if (requestParameters.notificationName !== undefined) {
            queryParameters['notification_name'] = requestParameters.notificationName;
        }

        if (requestParameters.notificationType !== undefined) {
            queryParameters['notification_type'] = requestParameters.notificationType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/notifications/preview/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async previewNotification(requestParameters: PreviewNotificationRequest): Promise<string> {
        const response = await this.previewNotificationRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListNotificationsNotificationTypeEnum {
    Email = 'EMAIL',
    Mail = 'MAIL',
    Slack = 'SLACK',
    Sms = 'SMS'
}
/**
    * @export
    * @enum {string}
    */
export enum NotifyNotificationTypeEnum {
    Email = 'EMAIL',
    Mail = 'MAIL',
    Slack = 'SLACK',
    Sms = 'SMS'
}
/**
    * @export
    * @enum {string}
    */
export enum PreviewNotificationNotificationTypeEnum {
    Email = 'EMAIL',
    Mail = 'MAIL',
    Slack = 'SLACK',
    Sms = 'SMS'
}
